import type { LeaveStatus } from "../../../../../../core/data/redux/admin-leaves/types";

export const STATUS_OPTIONS: { value: LeaveStatus; label: string }[] = [
  { value: "pending", label: "Pending" },
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" },
  { value: "cancelled", label: "Cancelled" },
];

export const STATUS_COLORS: Record<LeaveStatus, string> = {
  approved: "green",
  rejected: "red",
  pending: "gold",
  cancelled: "default",
};

export const ROW_LIMITS = [10, 25, 50, 100];
